// @flow

import styled, { css } from 'styled-components';

export const Margin = styled.div`
  ${props => props.all != null && css`
    margin: calc(0.5em * ${props.all});
  `}

  ${props => props.top != null && css`
    margin-top: calc(0.5em * ${props.top});
  `}

  ${props => props.noFirst && css`
    &:first-child {
      margin-top: 0;
    }
  `}
`;
